import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F112 {
  f112_01: string;        // 工繳代號 (PK, max 6 chars)
  f112_11: string;        // 工繳名稱 (max 40 chars)
  f112_12: string;        // 備註
  f112_14: string;        // 製程代號 (max 6 chars)
  f112_15: boolean;       // 舊代號旗標
  f112_16: boolean;       // 停用旗標
  f112_27: string;        // 建檔人員代號
  f112_28: string | null; // 異動日期
  f112_29: string | null; // 建檔日期
}

/** Extended response with F11U reference data (read-only, from GetByID) */
export interface F112WithRefs extends F112 {
  f11u_111: string; // 製程材質1名稱
  f11u_112: string; // 製程材質1規格
  f11u_121: string; // 製程材質2名稱
  f11u_122: string; // 製程材質2規格
  f11u_132: string; // 製程材質3規格
  f11u_141: string; // 製程材質4名稱
  f11u_142: string; // 製程材質4規格
  f11u_151: string; // 製程材質5名稱
  f11u_152: string; // 製程材質5規格
  f11u_161: string; // 製程材質6名稱
  f11u_162: string; // 製程材質6規格
  f11u_171: string; // 製程材質7名稱
  f11u_172: string; // 製程材質7規格
  f11u_181: string; // 製程材質8名稱
  f11u_182: string; // 製程材質8規格
}

export interface CreateRequest {
  f112_01: string;
  f112_11: string;
  f112_12: string;
  f112_14: string;
  f112_15: boolean;
  f112_16: boolean;
}

export interface UpdateRequest {
  f112_11: string;
  f112_12: string;
  f112_14: string;
  f112_15: boolean;
  f112_16: boolean;
}

export interface ListResponse {
  data: F112[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const processingFeeApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/processing-fee', { params });
    return res.data;
  },

  async get(code: string): Promise<F112WithRefs> {
    const res = await apiClient.get(`/api/processing-fee/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F112> {
    const res = await apiClient.post('/api/processing-fee', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F112> {
    const res = await apiClient.put(`/api/processing-fee/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/processing-fee/${encodeURIComponent(code)}`);
  },
};
